import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { SectionTitle } from 'page/ProfileScreen/basic/SectionTitle'
import { BodySizes } from 'page/ProfileScreen/BodySizes/BodySizes'
import { Thicknesses } from 'page/ProfileScreen/BodySizes/Thicknesses'
import { BustSizes } from 'page/ProfileScreen/BustSizes/BustSizes'
import { Genders } from 'page/ProfileScreen/Genders/Genders'
import { Heights } from 'page/ProfileScreen/Heights/Heights'
import { Legs } from 'page/ProfileScreen/Legs/Legs'
import { Modes } from 'page/ProfileScreen/Modes/Modes'
import { DetailedForm } from 'page/ProfileScreen/ProfileForm/DetailedForm'
import { SelfiesPanel } from 'page/ProfileScreen/Selfies/SelfiesPanel'
import { StandSelfiesPanel } from 'page/ProfileScreen/Selfies/StandSelfiesPanel'
import { Shapes } from 'page/ProfileScreen/Shapes/Shapes'
import { SkinColors } from 'page/ProfileScreen/SkinColors/SkinColors'
import { Units } from 'page/ProfileScreen/Units/Units'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { IdentityMode } from 'type/Identity'
import { showUnits } from 'type/LengthUnit'
import { DashedButton } from '../basic/DashedButton'

function renderBase() {
  const { gender } = store.profile
  const female = gender === 'female'

  return (
    <>
      <SectionTitle>
        {i18n('ChooseBodySize')}
      </SectionTitle>
      <Gap height={12} />
      <BodySizes />
      {female && (
        <>
          <Gap height={32} />
          <SectionTitle>
            {i18n('ChooseBustSize')}
          </SectionTitle>
          <Gap height={12} />
          <BustSizes />
        </>
      )}
    </>
  )
}

function renderExtended(onInfo: () => void) {
  const units = showUnits()
  const tsum = opt.tsum

  return (
    <>
      {units && <Units />}
      {units && <Gap height={32} />}
      <SectionTitle>
        {i18n('ChooseBodyType')}
      </SectionTitle>
      <Gap height={12} />
      <Shapes />
      <Gap height={32} />
      <SectionTitle>
        {i18n('ChooseBodyThickness')}
      </SectionTitle>
      <Gap height={12} />
      <Thicknesses />
      <Gap height={32} />
      <SectionTitle>
        {i18n('ChooseHeight')}
      </SectionTitle>
      <Gap height={12} />
      <Heights />
      {!tsum && (
        <>
          <Gap height={32} />
          <Space gap={16} opposite wrap>
            <SectionTitle>
              {i18n('ChooseLegLength')}
            </SectionTitle>
            <DashedButton onClick={onInfo}>
              {i18n('HowToChooseLegLength')}
            </DashedButton>
          </Space>
          <Gap height={12} />
          <Legs />
        </>
      )}
    </>
  )
}

export const ProfileForm = observer(() => {
  const color = false
  const { stand } = opt
  const { mode } = store.profile.form
  const body = opt.body.length > 1

  const onInfo = useLatestCallback(() => {
    store.profile.step = 'sizes'
  })

  const genders = <>
    <SectionTitle>
      {i18n('profile.Gender')}
    </SectionTitle>
    <Gap height={12} />
    <Genders />
    <Gap height={32} />
  </>

  return (
    <Vertical>
      {!stand && genders}

      {stand ? <StandSelfiesPanel /> : <SelfiesPanel />}

      {color && <Gap height={32} />}
      {color && (
        <SectionTitle>
          {i18n('SkinColor')}
        </SectionTitle>
      )}
      {color && <Gap height={12} />}
      {color && <SkinColors />}

      <Gap height={32} />

      {stand && genders}

      {body && <>
        <SectionTitle>
          {i18n('BodySettings')}
        </SectionTitle>
        <Gap height={12} />
        <Modes />
        <Gap height={32} />
      </>}

      {mode === IdentityMode.BASE && renderBase()}
      {mode === IdentityMode.EXTENDED && renderExtended(onInfo)}
      {mode === IdentityMode.DETAILED && <DetailedForm />}
    </Vertical>
  )
})
